import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], field: string, value: string): any[] {
    if (!items) return [];
    if (!value || value.length == 0) return items;
    return items.filter(item => {
      if(item.isOtherOption){
        return true;
      }
      return FilterPipe.preprocess(item[field])?.startsWith(FilterPipe.preprocess(value))
    })
  }

  private static preprocess(val: string): string {
    return val?.trim().toLowerCase().replace(/\s/g,'');
  }
}
